import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import Subtitle from 'Components/ComponentLibrary/Atoms/Text/Subtitle';
import WelcomeParagraphs from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/WelcomeParagraphs';
import { Box, Button } from '@material-ui/core';
import fr from 'facet-rest';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import FileItem from 'Views/Page/Content/Modal/Layouts/SelectFileStepLayout/Content/FileItem';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';

const styles = theme => ({
  root: {
    width: '100%',
    margin: 'auto',
    display: 'flex',
    maxWidth: '400px',
    alignItems: 'center',
    flexDirection: 'column',
    marginBottom: theme.spacing(10),
    padding: theme.spacing(2),
  },
  rootDesktop: {
    maxWidth: '600px',
  },
  content: {
    width: '100%',
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(4),
  },
  subtitle: {
    fontWeight: theme.typography.fontWeightBold,
    padding: 0,
    marginBottom: theme.spacing(2),
  },
  subtitles: {
    fontWeight: theme.typography.fontWeightBold,
    padding: 0,
  },
  subtitleText: {
    textAlign: 'center',
  },
  bold: {
    fontWeight: theme.typography.fontWeightBold,
  },
});

const Content = ({
  classes,
  setCollection,
}) => {
  const {
    resource,
  } = useMetaLayoutContext();
  const isMobile = useMobileLayout();

  async function handleClick(item, isFolder) {
    if (isFolder) {
      try {
        const newItemCollection = await item.relationship(fr.relationships.folder.name).link('related').get();
        setCollection(newItemCollection);
      } catch (e) {
        displayErrorMessage(e, 'Failed to load folder');
      }
    } else {
      // File select
      try {
        if (item.meta().action('POST')) {
          await item.link('self').post();
        } else if (item.meta().action('DELETE')) {
          await item.link('self').delete();
        }
        const newItemCollection = await resource.link('self').get();
        setCollection(newItemCollection);
      } catch (e) {
        displayErrorMessage(e, 'Failed to select file');
      }
    }
  }

  let subtitles = null;
  if (resource.attr('subtitle')) {
    subtitles = Array.isArray(resource.attr('subtitle')) ? (
      <WelcomeParagraphs
        className={classes.subtitles}
        paragraphs={resource.attr('subtitle').map(text => ({ text }))}
        classes={{ text: classes.subtitleText }}
        variant="h6"
      />
    ) : (
      <Subtitle className={classes.subtitle} text={resource.attr('subtitle')} test={'wizard-step-subtitle'} />
    );
  }

  const parentFolderRelationship = resource.relationship(fr.relationships.parentFolder.name);

  return (
    <div className={classNames(classes.root, {
      [classes.rootDesktop]: !isMobile,
    })}
    >
      {resource.attr('title')
        ? <Title className={classes.title} text={resource.attr('title')} test={'wizard-step-title'} /> : null}
      {subtitles}
      <Box className={classes.content}>
        {
          parentFolderRelationship ? (
            <Button
              size="medium"
              className={classes.bold}
              color="primary"
              onClick={async () => {
                try {
                  const newItemCollection = await parentFolderRelationship.link('related').get();
                  setCollection(newItemCollection);
                } catch (e) {
                  displayErrorMessage(e, 'Failed to load parent folder');
                }
              }}
            >
              <Text variant="h5" weight="bold">
                {`< ${parentFolderRelationship.meta('prompt')}`}
              </Text>
            </Button>
          ) : undefined
        }
        {
          resource.attr('fileOptions').resources().list().map(item => {
            const isFolder = item.relationship(fr.relationships.folder.name);
            const isLinked = item.attr('isLinked') === 'true';

            return (
              <FileItem
                key={item.id}
                fileCount={item.attr('fileCount')}
                label={item.attr('name')}
                link={item.relationship(fr.relationships.download.name)
                  ? item.relationship(fr.relationships.download.name).link('related').url()
                  : undefined
                }
                checked={isLinked}
                isFolder={isFolder}
                onClick={() => handleClick(item, isFolder)}
              />
            );
          })
         }
      </Box>
    </div>
  );
};

Content.propTypes = {
  classes: PropTypes.object.isRequired,
  setCollection: PropTypes.func.isRequired,
};

export default withStyles(styles)(Content);
